// extracted by mini-css-extract-plugin
export var modalFooter = "_pb-0";